import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { timeout, catchError, tap } from 'rxjs/operators';

/**
 * Intercept HTTP Request, catch and throw error when HTTP Request exceeding timeout time (in ms).
 */
@Injectable({
  providedIn: 'root',
})
export class TimeoutInterceptor implements HttpInterceptor {
  private readonly TIMEOUT: number = 1000 * 60 * 30;

  constructor() {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      timeout(this.TIMEOUT),
      catchError((error) => {
        // console.error(error);
        return throwError(error);
      })
    );
  }
}
